<template>
  <div class="toast-container">
    <div
      v-for="toast in allToasts"
      :key="toast.creationTimestamp"
      :class="'alert alert-' + toast.type"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {{ toast.message }}
      <button
        @click="clearToast(toast)"
        type="button"
        class="ml-2 mb-1 close"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters('toast', ['allToasts']),
  },
  methods: {
    ...mapMutations('toast', ['clearToast']),
  },
}
</script>

<style lang="scss">
.toast-container {
  position: absolute;
  bottom: 0;
  right: 0.5em;
  left: 0.5em;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  .alert {
    margin-bottom: 10px;
  }
}
</style>
